module.exports = __webpack_public_path__ + "img/volume.c52790ae.svg";